import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { TableCell, TableRow, Typography } from '@mui/material';
import { Add, ErrorOutlineOutlined } from '@mui/icons-material';

import Table from '../../components/Table';
import Modal from '../../components/Modal';
import Button from '../../components/Button';
import FilterInput from '../../components/Filter/FilterInput';
import EmptyState from '../../components/EmptyState';
import Pagination from '../../components/Pagination';
import SearchInput from '../../components/SearchInput';
import RadioButtonsGroup from '../../components/RadioButton';
import DatePicker from '../../components/DatePicker';
import FilterLabel from '../../components/Filter/FilterLabel';
import Tooltip from '../../components/Tooltip';
import { DeleteBgIcon, EditBgIcon, EditIcon, ViewBgIcon } from '../../utils/Icons';
import { ROUTE_PATHS } from '../../utils/RoutesPaths';
import { isSuperAdmin } from '../../utils/Permissions';
import { renderFormatedDate } from '../../utils/DateHelpers';
import { renderTextEllipsis, textContainOnlySpaces, setPageMainTitle } from '../../utils/Helpers';
import { providerStatusList, providerStatusChangeActions } from '../../utils/Constants';
import { getProvidersRequest, deleteProviderRequest, editProviderRequest, getRequestStatus } from '../../store/Providers/actions';
import { getCategoriesRequest } from '../../store/Categories/actions';
import messages from '../../assets/locale/messages';
import userImage from '../../assets/images/user-profile-image.png';
import './Service-providers.scss';
import {
  addBranchDataInStore,
  addBranchResponse,
  getAddressFromCoordsResponse,
  getBranchResponse,
  getBranchServicesResponse,
} from '../../store/Branches/actions';
import { getGoogleMapsCoords, saveBranchData, getGoogleMapsPolygon } from '../../store/GoogleMapCoords/actions';

const ServiceProviders = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.loader);
  const lang = useSelector((state) => state.locale.lang);
  const list = useSelector((state) => state.providers.list);
  const meta = useSelector((state) => state.providers.meta);
  const categoriesList = useSelector((state) => state.categories.list);
  const requestStatus =useSelector((state) => state.providers.requestStatus);
  const { shared, serviceProviders, pagesTitles } = messages[lang];

  const [page, setPage] = useState(1);
  const [searchValue, setSearchValue] = useState('');
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [openSusbendByTime, setOpenSusbendByTime] = useState(false);
  const [deleteServiceProviderId, setdeleteServiceProviderId] = useState(null);
  const [statusValue, setStatusValue] = useState(null);
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  const [filterCategoryValue, setFilterCategoryValue] = useState(null);
  const [filterProviderStatus, setFilterProviderStatus] = useState(null);
  const [statusChanged, setStatusChanged] = useState(false);
  const [susbendedAt, setSusbendedAt] = useState(null);
  const [invalidDeactivatingDate, setInvalidDeactivatingDate] = useState(false);
  const [providerIdWithSusbendedAt, setProviderIdWithSusbendedAt] = useState(null);

  useEffect(() => {
    setPageMainTitle('serviceProvidersManagement');
    getCategoriesLookup();
    clearAddBranchSavedDataInStore();
  }, []);

  useEffect(() => {
    if(requestStatus){
      getProviders(
        page,
        searchValue,
        filterCategoryValue?.id,
        filterProviderStatus?.id
      );
    }
  }, [requestStatus])

  const clearAddBranchSavedDataInStore = () => {
    dispatch(getBranchResponse({}));
    dispatch(getBranchServicesResponse({}));
    dispatch(addBranchDataInStore({}));
    dispatch(addBranchResponse({}));
    dispatch(getAddressFromCoordsResponse({}));
    dispatch(saveBranchData({}));
    dispatch(getGoogleMapsPolygon([]));
    dispatch(getGoogleMapsCoords({}));
  };

  // API CALL list
  const getProviders = (pageNo, search, category_id, status) => {
    dispatch(
      getProvidersRequest({
        page: pageNo,
        items: 10,
        query: search,
        category_id,
        status,
      })
    );
  };
  // API CALL look up
  const getCategoriesLookup = () => {
    dispatch(
      getCategoriesRequest({
        page: -1,
      })
    );
  };

  // useeffect page
  useEffect(() => {
    getProviders(page, searchValue, filterCategoryValue?.id, filterProviderStatus?.id);
  }, [page]);

  // useeffect search
  useEffect(() => {
    if ((searchValue.length >= 3 || searchValue.length === 0) && !textContainOnlySpaces(searchValue)) {
      setPage(1);
      getProviders(1, searchValue, filterCategoryValue?.id, filterProviderStatus?.id);
    }
  }, [searchValue]);

  // useeffect category
  useEffect(() => {
    setPage(1);
    getProviders(1, searchValue, filterCategoryValue?.id, filterProviderStatus?.id);
  }, [filterCategoryValue]);

  // useeffect category
  useEffect(() => {
    if (statusChanged) {
      setPage(1);
      getProviders(1, searchValue, filterCategoryValue?.id, filterProviderStatus?.id);
      setStatusChanged(false);
    }
  }, [filterProviderStatus]);

  const providerStatusOptions = [
    {
      id: providerStatusList.active,
      label: serviceProviders.list.status.active,
    },
    {
      id: providerStatusList.blocked,
      label: serviceProviders.list.status.blocked,
    },
    {
      id: providerStatusList.deactivated,
      label: serviceProviders.list.status.deactivated,
    },
    {
      id: providerStatusList.suspended,
      label: serviceProviders.list.status.suspended,
    },
  ];

  const editStatusActions = [
    {
      id: 0,
      value: providerStatusChangeActions.activate,
      label: serviceProviders.list.statusActions.activate,
    },
    {
      id: 1,
      value: providerStatusChangeActions.block,
      label: <div className="d-flex align-items-center">
                <div>{serviceProviders.list.statusActions.block}</div>
                <div>
                  <Tooltip 
                    title={serviceProviders.list.blockProviderHint}
                    content={<span className="mx-1"><ErrorOutlineOutlined color="secondary"/></span>}
                  />
                </div>
             </div>,
    },
    {
      id: 2,
      value: providerStatusChangeActions.deactivateImmediately,
      label: serviceProviders.list.statusActions.deactivateNow,
    },
    {
      id: 3,
      value: providerStatusChangeActions.deactivateLater,
      label: serviceProviders.list.statusActions.deacivateLater,
    },
  ];

  // To update filters options with lang change
  useEffect(() => {
    setCategoriesOptions(
      categoriesList.map((option) => ({
        id: option.id,
        label: lang === 'en' ? option.title_en : option.title_ar,
      }))
    );
  }, [lang, categoriesList]);

  // To update filters values with lang change
  useEffect(() => {
    if (filterCategoryValue)
      setFilterCategoryValue(categoriesOptions.find((option) => option.id === filterCategoryValue.id));
    if (filterProviderStatus) {
      setFilterProviderStatus(providerStatusOptions.find((option) => option.id === filterProviderStatus.id));
      setStatusChanged(false);
    }
  }, [lang, categoriesOptions]);

  useEffect(() => {
    if (statusValue === providerStatusChangeActions.deactivateLater) {
      setOpenSusbendByTime(true);
      setProviderIdWithSusbendedAt(selectedProvider);
    } else {
      setOpenSusbendByTime(false);
    }
  }, [statusValue]);

  const handleEditServiceProviders = (id) => {
    history.push(ROUTE_PATHS.editServiceProvider.replace(':id', id));
  };

  const handleViewServiceProviders = (id) => {
    history.push(ROUTE_PATHS.viewServiceProvider.replace(':id', id));
  };

  const handleDeleteClick = (id) => {
    setdeleteServiceProviderId(id);
    setOpenDeleteConfirm(true);
  };

  const handleStatusClick = (provider) => {
    setSelectedProvider(provider);
    setOpenStatusModal(true);
  };

  const handleDeleteServiceProvider = () => {
    dispatch(
      deleteProviderRequest({
        id: deleteServiceProviderId,
        currentPage: meta.currentPage,
      })
    );
    setOpenDeleteConfirm(false);
  };

  const handleCloseDeleteConfirmModal = () => {
    setOpenDeleteConfirm(false);
  };

  const handleCloseStatusModal = () => {
    setOpenStatusModal(false);
    setOpenSusbendByTime(false);
    setProviderIdWithSusbendedAt(null);
    setSusbendedAt(null);
    setSelectedProvider(null);
    setStatusValue(null);
  };

  const handleChangeStatus = () => {
    let providerData;
    if (statusValue) {
      switch (statusValue) {
        case providerStatusChangeActions.activate:
          providerData = { status: providerStatusList.active };
          break;
        case providerStatusChangeActions.block:
          providerData = { status: providerStatusList.blocked };
          break;
        case providerStatusChangeActions.deactivateImmediately:
          providerData = { status: providerStatusList.deactivated };
          break;
        default:
          providerData = {
            status: providerStatusList.deactivationScheduled,
            deactivation_datetime: susbendedAt,
          };
          break;
      }
    }
    dispatch(
      editProviderRequest({
        id: selectedProvider.id,
        data: providerData,
        currentPage: meta.currentPage,
      })
    );
    handleCloseStatusModal();
    dispatch(getRequestStatus(null))
  };

  const renderStatusCase = (row) => {
    if (row.status === providerStatusList.blockSuspended) {
      return (
        <Tooltip
          title={serviceProviders.list.suspendedByBlock}
          content={<span>{RenderTitle(row.status)}</span>}
          hasArrow
        />
      );
    } else if (row.status === providerStatusList.deactivationScheduled && row.deactivation_datetime) {
      return (
        <Tooltip
          title={`${serviceProviders.list.suspendedByDeactivateProvider} ${renderFormatedDate(
            row.deactivation_datetime
          )}`}
          content={<span>{RenderTitle(row.status)}</span>}
          hasArrow
        />
      );
    } else {
      return <span>{RenderTitle(row.status)}</span>;
    }
  };

  const RenderTitle = (title) => {
    switch (title) {
      case providerStatusList.active:
        return `${serviceProviders.list.status.active}`;
      case providerStatusList.deactivated:
        return `${serviceProviders.list.status.deactivated}`;
      case providerStatusList.blockSuspended:
        return `${serviceProviders.list.status.suspended}`;
      case providerStatusList.blocked:
        return `${serviceProviders.list.status.blocked}`;
      case providerStatusList.deactivationScheduled:
        return `${serviceProviders.list.status.suspended}`;
      default:
        return `-`;
    }
  };

  const renderHeaderSection = (showActions) => (
    <>
      <div className="services-header mb-4">
        <div className="title-search">
          <Typography variant="h4" sx={{ flexGrow: 1 }} className={`page-title ${lang === 'en' ? 'me-2' : 'ms-2'}`}>
            {pagesTitles.serviceProviders}
          </Typography>
        </div>
      </div>
      {showActions && (
        <div className="d-flex justify-content-between flex-column flex-lg-row">
          <SearchInput
            className="filter-label-wrapper"
            placeholder={serviceProviders.list.search}
            name="search"
            value={searchValue}
            onChange={(value) => {
              setSearchValue(value);
            }}
          />
          {isSuperAdmin() && showActions && (
            <div className={`add-btn-wrapper my-4 mt-lg-0 ${lang === 'en' ? 'text-end' : 'text-start'}`}>
              <Button
                label={
                  <span className="d-flex align-items-center">
                    <Add fontSize="large" />
                    <span className="ps-1 adjust-font-size-small-screen">{serviceProviders.list.CreateButton}</span>
                  </span>
                }
                labelClass="fsize-16 text-white pe-2 adjust-CTA"
                onClick={() => {
                  history.push(ROUTE_PATHS.addServiceProvider);
                }}
              />
            </div>
          )}
        </div>
      )}
      {showActions && (
        <div className="filter-label-wrapper d-flex align-items-center mb-4 w-50 gap-2 flex-wrap flex-md-nowrap">
          <FilterLabel />
          <FilterInput
            placeholder={serviceProviders.list.filter.filtersPlaceHolders.filterByCategory}
            options={categoriesOptions}
            value={filterCategoryValue}
            name="Category Filter"
            onChange={(value) => {
              setFilterCategoryValue(value);
            }}
            filterWrapperClass="my-3 my-md-0 w-100"
          />
          <FilterInput
            placeholder={serviceProviders.list.filter.filtersPlaceHolders.filterByProviderStatus}
            options={providerStatusOptions}
            value={filterProviderStatus}
            name="provider status Filter"
            onChange={(value) => {
              setStatusChanged(true);
              setFilterProviderStatus(value);
            }}
            filterWrapperClass="my-3 my-md-0 w-100"
          />
        </div>
      )}
    </>
  );

  const handleStatusList = (provider) => {
    let list;
    // active case
    if (provider.status === providerStatusList.active) {
      list = editStatusActions.filter((action) => action.value !== providerStatusChangeActions.activate);
    } else if (
      provider.status === providerStatusList.deactivated ||
      provider.status === providerStatusList.deactivationScheduled
    ) {
      list = editStatusActions.filter(
        (action) =>
          action.value !== providerStatusChangeActions.deactivateImmediately &&
          action.value !== providerStatusChangeActions.deactivateLater
      );
    } else if (provider.status === providerStatusList.blocked) {
      list = editStatusActions.filter(
        (action) =>
          action.value !== providerStatusChangeActions.block &&
          action.value !== providerStatusChangeActions.deactivateLater
      );
    } else if (provider.status === providerStatusList.blockSuspended) {
      list = editStatusActions.filter(
        (action) =>
          action.value !== providerStatusChangeActions.deactivateImmediately &&
          action.value !== providerStatusChangeActions.deactivateLater &&
          action.value !== providerStatusChangeActions.block
      );
    }
    return list;
  };

  const ServiceProvidersList = () => {
    if (!isLoading && list?.length === 0 && !searchValue && !filterProviderStatus && !filterCategoryValue) {
      return (
        <>
          {renderHeaderSection(false)}
          <div className="bg-white rounded-4 providers-page d-flex justify-content-center align-items-center flex-column m-4">
            <EmptyState
              subTitle={shared.noData}
              description={serviceProviders.list.noDataDescription}
              ButtonLabel={serviceProviders.list.CreateButton}
              handleBtnAction={() => {
                history.push(ROUTE_PATHS.addServiceProvider);
              }}
              showActionButton={isSuperAdmin()}
            />
          </div>
        </>
      );
    } else if (!isLoading && (searchValue || filterProviderStatus || filterCategoryValue) && list?.length === 0) {
      return (
        <>
          {renderHeaderSection(true)}
          <div className="bg-white rounded-4 providers-page d-flex justify-content-center align-items-center flex-column m-4">
            <EmptyState subTitle={shared.noSearch} showActionButton={false} />
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className="Providers-page">
            {renderHeaderSection(true)}
            <div className="bg-white rounded-4 my-3 providers-table-list">
              <Table
                headlines={['', shared.lists.name, shared.lists.email, shared.lists.category, shared.lists.status]}
                hasActions={true}
                rows={list?.map((row, i) => (
                  <TableRow key={i}>
                    <TableCell className="font-regular text-dark-blue fsize-14 ">
                      <div
                        style={{
                          backgroundImage: `url(${row.logo_image ?? userImage})`,
                        }}
                        className="provider-logo mx-auto"></div>
                    </TableCell>
                    <TableCell className="font-regular text-dark-blue fsize-14 ">
                      <div className="d-flex align-items-center justify-content-center gap-2">
                        <p className="m-0">
                          {row.name_en || row.name_ar
                            ? lang === 'en'
                              ? renderTextEllipsis(row.name_en)
                              : renderTextEllipsis(row.name_ar)
                            : '-'}
                        </p>
                      </div>
                    </TableCell>
                    <TableCell className="font-regular text-dark-blue fsize-14 ">
                      {row.email ? row.email : '-'}
                    </TableCell>
                    <TableCell className="font-regular text-dark-blue fsize-14 ">
                      {row.category
                        ? lang === 'en'
                          ? renderTextEllipsis(row.category.name_en)
                          : renderTextEllipsis(row.category.name_ar)
                        : '-'}
                    </TableCell>
                    <TableCell className="font-regular text-dark-blue fsize-14 ">
                      <div className="d-flex flex-column ">
                        <div
                          className={`status status-${row.status} px-3 py-2 border-radius-10 text-center position-relative`}>
                          <span className="d-inline-block me-2">{renderStatusCase(row)}</span>
                          {isSuperAdmin() && (
                            <EditIcon
                              className={`pointer position-absolute svg-${row.status}`}
                              onClick={() => {
                                handleStatusClick(row);
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </TableCell>
                    <TableCell className="font-regular text-dark-blue fsize-14 ">
                      <div className="table-icons-container gap-4">
                        {isSuperAdmin() && (
                          <EditBgIcon className="pointer" onClick={() => handleEditServiceProviders(row.id)} />
                        )}
                        <ViewBgIcon
                          className="pointer"
                          onClick={() => {
                            clearAddBranchSavedDataInStore();
                            handleViewServiceProviders(row.id);
                          }}
                        />
                        {isSuperAdmin() && (
                          <DeleteBgIcon className="pointer" onClick={() => handleDeleteClick(row.id)} />
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              />
              <div className="d-flex justify-content-center py-3">
                {meta?.pages > 1 && (
                  <Pagination
                    count={meta?.pages}
                    page={meta?.currentPage || page}
                    handleChange={(event, page) => {
                      setPage(page);
                    }}
                    defaultPage={1}
                  />
                )}
              </div>
            </div>
          </div>
          <Modal
            open={openStatusModal}
            handleClose={handleCloseStatusModal}
            title={serviceProviders.list.editStatus}
            contentClass="mb-3 text-primary"
            content={
              <>
                <RadioButtonsGroup
                  isLabel={false}
                  defaultValue
                  name="providerStatus"
                  list={handleStatusList(selectedProvider ?? {})}
                  onChange={(e) => setStatusValue(e.target.value)}
                />
                {openSusbendByTime && (
                  <div className="mt-3">
                    <DatePicker
                      value={susbendedAt}
                      onChange={(dateValue) => {
                        setSusbendedAt(dateValue);
                      }}
                      name={'susbended at'}
                      disablePast={true}
                      label={serviceProviders.list.statusActions.dateLabel}
                      disableMinToday={true}
                      placement="right"
                      setInvalidDeactivatingDate={setInvalidDeactivatingDate}
                    />
                  </div>
                )}
              </>
            }
            isContentText={false}
            confirmBtnTxt={shared.save}
            maxWidth="xs"
            cancelBtnTxt={shared.cancel}
            handleConfirm={handleChangeStatus}
            handleCancel={handleCloseStatusModal}
            modalClass="status-modal"
            actionsClass="container px-4"
            confirmBtnClass="btn-secondary fsize-14 text-white py-2 "
            cancelBtnClass="fsize-14 py-2"
            disableActionBtn={statusValue ==='deactivate-later' 
                                ? !(susbendedAt && statusValue) || invalidDeactivatingDate 
                                : !statusValue}
          />
          <Modal
            open={openDeleteConfirm}
            handleClose={handleCloseDeleteConfirmModal}
            title={serviceProviders.deleteServiceProvider.title}
            contentClass="mb-3 text-primary"
            content={<span>{serviceProviders.deleteServiceProvider.deleteConfirmationMsg}</span>}
            isContentText={false}
            confirmBtnTxt={shared.delete}
            maxWidth="xs"
            cancelBtnTxt={shared.cancel}
            handleConfirm={handleDeleteServiceProvider}
            handleCancel={handleCloseDeleteConfirmModal}
            modalClass="delete-categories-modal"
            actionsClass="container px-4"
            confirmBtnClass="btn-secondary fsize-14 text-white py-2 "
            cancelBtnClass="fsize-14 py-2"
          />
        </>
      );
    }
  };
  return <>{ServiceProvidersList()}</>;
};

export default ServiceProviders;
